import { t } from "i18next";
import { EVENT_LINK_PLAYSTORE, EVENT_LINK_WHATSAPP, REDIRECT_URL, sendTapEvent, WHATSAPP_LINK } from "../../helper/helper";
import { ReactComponent as Check } from "../../rsc/check.svg";
import { colorPrimaryDark } from "../../rsc/colors";
import GooglePlayStoreg from "../../rsc/playstore.png";
import Whatsapp from "../../rsc/whatsapp.png";
import "./ContactToSellMyFruitV3.scss";

type Props = {
    style?: React.CSSProperties
}

export function ContactToSellMyFruitV3({ style }: Props) {

    const styleCombined: React.CSSProperties = style ? style : { boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", borderRadius: "8px" }

    return (<div
        style={{
            ...styleCombined,
            display: "flex", flexDirection: "column", background: "#fff", padding: "20px", gap: "10px"
        }}>
        <div style={{ display: "flex", alignItems: "center" }}>
            <p className="text-extra-big" style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('call_pempem')}</p>
        </div>
        <p className="text-very-big" style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('fetch_price_title')}</p>

        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "10px", marginTop: "10px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <Check />
                <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: 600 }}>{t('transport_included')}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "600" }}>
                <Check />
                <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: "600" }}>{t('no_grading_at_farm')}</p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <Check />
                <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: "600" }}>{t('digital_scale')}</p>
            </div>
        </div>
        <p className="text-very-big" style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('call_pempem_message')}</p>

        <a href={WHATSAPP_LINK} style={{ textDecoration: "none" }} onClick={() => sendTapEvent(EVENT_LINK_WHATSAPP)}>
            <div
                style={{
                    background: "#25D366",
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: "8px",
                    height: "60px",
                    gap: "10px", alignItems: "center", cursor: "pointer"
                }} >
                <img alt="" src={Whatsapp} height={"60px"}></img>
            </div>
        </a>

        <p className="text-very-big" style={{ color: colorPrimaryDark, fontWeight: "600" }}>{t('download_pempem_app_instruction_for_price')}</p>

        <a href={REDIRECT_URL} onClick={() => sendTapEvent(EVENT_LINK_PLAYSTORE)}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    background: 'black',
                    cursor: "pointer",
                    borderRadius: "8px",
                    height: "60px",
                    alignItems: "center"
                }} >
                <img alt="background" style={{ height: "40px" }} src={GooglePlayStoreg} />
            </div>
        </a>
    </div>)
}